<template>
    <div :class="[$store.state.hftype==1?'footer':'footer2', 'modulewrap']">
        <div class="copyright" v-html="$common.langinfo(footerinfo.content,footerinfo.content_en).replace('@@','&copy;')"></div>
    </div>
</template>

<script>
    export default {
        name: 'Cfooter',
        data() {
            return {
                footerinfo: ''
            }
        },
        mounted() {
            this.$common.fetch({ 'act': 'te_footer' }, res => {
                this.footerinfo = res.infodata;
            });
        }
    };
</script>
